import type { ReactNode } from "react";

const BASE_CLASS =
  " max-h-[73px] fixed bottom-0 left-0 z-[99999] hidden min-h-[73px] w-screen pr-[73px] shadow-[-4px_-4px_6px_#00000014] md:flex";

interface OpenDematFloatBannerDesktopShellServerProps {
  children: ReactNode;
}

const OpenDematFloatBannerDesktopShellServer = ({
  children,
}: OpenDematFloatBannerDesktopShellServerProps) => {
  return (
    <div className={BASE_CLASS} aria-live="polite">
      {children}
    </div>
  );
};

export default OpenDematFloatBannerDesktopShellServer;
